import { QueryClient } from "@tanstack/react-query";

/**
 * Cliente ÚNICO de React Query del panel de seguridad (ítem 15, Fase 1).
 *
 * Defaults alineados con el front principal: datos "frescos" 60 s (`staleTime`), recolección a los
 * 5 min (`gcTime`), sin refetch al enfocar la ventana (`refetchOnWindowFocus:false`), 1 reintento.
 *
 * SEGURIDAD (guardrail del ítem): la cache se PURGA en logout — `AuthProvider.authLogout` llama a
 * `queryClient.clear()` (además de `limpiarCacheSesion`) para no filtrar datos de una sesión a la
 * siguiente en la MISMA pestaña. Se expone como singleton para que el logout lo limpie sin depender
 * del árbol de contexto.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
